(function($) {
  var catList = [];
  var markerClusterer;

  /* Initialize Map */
  function initMap($el) {
    // Find marker elements within map.
    var $markers = $el.find('.marker');

    var lat = 48.390394;
    var lng = -4.486076;
    var zoom = 8;

    if (window.innerWidth < 1092) {
      lat = 48.117266;
      lng = -1.6777926;
    }

    // Create generic map.
    var mapArgs = {
      zoom: zoom,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      center: {
        lat: lat,
        lng: lng
      },
      styles: [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f5f5f5"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dadada"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#CFDFE9"
            }
          ]
        }
      ]
    };

    var map = new google.maps.Map($el[0], mapArgs);

    // Add markers.
    map.markers = [];
    catfilter(map, $markers);
    createMarkers(map, $markers);

    // Return map instance.
    return map;
  }

  /* Initialize Marker */
  function initMarker($marker, map) {
    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var color = $marker.data('color');

    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
      position: latLng,
      icon: {
        url: window.location.origin + "/wp-content/themes/ligue_35/images/" + getColor(color)
      }
    });

    function getColor(color) {
      switch (color) {
        case 'Rouge':
          return 'marker_rouge.svg';
        case 'Jaune':
          return 'marker_jaune.svg';
        case 'Noir':
          return 'marker_noir.svg';
        case 'Rose':
          return 'marker_rose.svg';
        case 'Orange':
          return 'marker_orange.svg';
        case 'Marron':
          return 'marker_marron.svg';
        case 'Verte':
          return 'marker_verte.svg';
        case 'Bleue':
          return 'marker_bleu.svg';
        case 'Bleue foncé':
          return 'marker_bleufonce.svg';
        case 'Beige':
          return 'marker_beige.svg';
        default:
          return '#FFFFFF'; // Default color if no match
      }
    }

    // If marker contains HTML, add it to an infoWindow.
    if ($marker.html()) {
      // Create info window.
      var infowindow = new google.maps.InfoWindow();

      // Show info window when marker is clicked.
      google.maps.event.addListener(marker, 'click', function() {
        var info = $marker.find('.marker__content').html();
        $('#infowindow').show();
        $('#infowindow').addClass('active');
        $('#infowindow').empty();
        $('#infowindow').append(info);
        $('.marker__content__close').on('click', externalInfowindow);
      });
    }

    function externalInfowindow() {
      $('#infowindow').empty();
      $('#infowindow').hide();
    }

    return marker; // Return the created marker.
  }

  // Filter based on category
  function catfilter(map, $markers) {
    $('.associationCategory__list__item > input').on('change', function(e) {
      // Scroll to the filter section
      $('html, body').animate({
        scrollTop: $('.associationCategory').offset().top
      }, 500);

      var selectedCategory = $(this).val();

      if (catList.includes(selectedCategory) === false) {
        catList.push(selectedCategory);
      } else {
        var index = catList.indexOf(selectedCategory);
        if (index !== -1) {
          catList.splice(index, 1);
        }
      }

      // Toggle checkbox style
      $(this).parents().toggleClass('not-selected');

      // Submit the form
      $(this).parents('form:first').submit();

      // Delete all markers from the map.
      deleteMarkers();

      // Recreate markers.
      createMarkers(map, $markers);
    });

    // Push all the value of category into an array
    var category = $('.associationCategory__list__item > input');
    for (var i = 0; i < category.length; i++) {
      catList.push(category[i].value);
    }
  }

  function deleteMarkers() {
    if (markerClusterer) {
      markerClusterer.clearMarkers();
    }
  }

  function createMarkers(map, $markers) {
    var markers = [];
  
    $markers.each(function() {
      var addedMarkers = {}; // Track added markers for each set
  
      var markerCat = $(this).data('cat');
      var markerCatArray = markerCat.split(' ');
  
      for (x = 0; x < markerCatArray.length; x++) {
        if (catList.includes(markerCatArray[x])) {
          var markerKey = $(this).data('lat') + '_' + $(this).data('lng'); // Create a unique key for each marker
      
          if (!addedMarkers[markerKey]) { // Check if the marker has already been added
            var marker = initMarker($(this), map);
            if (marker) {
              markers.push(marker);
              addedMarkers[markerKey] = true; // Add the marker key to the addedMarkers object
              console.log('Added marker:', markerKey);
            }
          }
        } else {
          var markerKey = $(this).data('lat') + '_' + $(this).data('lng'); // Create a unique key for each marker
          console.log('Skipped marker:', markerKey);
        }
      }
      
      console.log('Added markers:', markers);
      
    });
  
    // Create marker clusterer
    var imagePath = window.location.origin + "/wp-content/themes/ligue_35/images/cluster.svg";
    markerClusterer = new MarkerClusterer(map, markers, {
      maxZoom: 15,
      styles: [
        MarkerClusterer.withDefaultStyle({
          width: 56,
          height: 68,
          url: imagePath,
          textColor: "#0858A3",
          textSize: 32,
          anchorText: [-8, 0],
        })
      ],
    });
  }
  
  

  // Render maps on page load.
  $(document).ready(function() {
    $('.associationCategory__list__item > input').prop('checked', true);

    $('.associationCategory__list__item').on('click', function(e) {
      // Get the associated checkbox input
      var checkbox = $(this).find('input[type="checkbox"]');

      // Toggle checkbox state
      checkbox.prop('checked', !checkbox.prop('checked'));

      // Trigger change event on checkbox
      checkbox.trigger('change');
    });

    var formSubmitted = false;

    // Prevent page refresh when submitting form
    $('#assoCat-filter').on('submit', function(e) {
      e.preventDefault();

      if (!formSubmitted) {
        formSubmitted = true;
        var formData = new FormData(this);
        fetch(window.location.href, {
          method: 'POST',
          body: formData
        });
        return;
      }
    })

    if ($('.map').length) {
      $('.map').each(function() {
        var map = initMap($(this));
      });
    }
  });
})(jQuery);
